export function toArray(nodeList){return Array.prototype.slice.call(nodeList)}export default toArray;